import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getHomeSearchPath } from '../../pages/pathUtils';
import './curve-theme.css';

type MessageSearchTriggerProps = {
  onOpen?: () => void;
  isOpen?: boolean;
  onClose?: () => void;
};

export function MessageSearchTrigger({ onOpen, isOpen }: MessageSearchTriggerProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (onOpen) {
      onOpen();
    } else {
      navigate(getHomeSearchPath());
    }
  };

  return (
    <button
      onClick={handleClick}
      title={t('SearchBar.message_search')}
      className="curve-btn"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '28px',
        height: '28px',
        borderRadius: 'var(--curve-radius-sm, 4px)',
        border: `1px solid ${isOpen ? 'var(--curve-primary, #22C55E)' : 'var(--curve-border, #E5E5E5)'}`,
        background: isOpen ? 'var(--curve-primary-soft, #F0FDF4)' : 'var(--curve-bg-white, #FFFFFF)',
        color: isOpen ? 'var(--curve-primary, #22C55E)' : 'var(--curve-text-muted, #64748B)',
        fontSize: '13px',
        cursor: 'pointer',
        flexShrink: 0,
        transition: 'border-color var(--curve-transition), background var(--curve-transition)',
      }}
      onMouseEnter={(e) => {
        if (!isOpen) {
          (e.currentTarget as HTMLButtonElement).style.borderColor =
            'var(--curve-primary, #22C55E)';
          (e.currentTarget as HTMLButtonElement).style.color =
            'var(--curve-primary, #22C55E)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isOpen) {
          (e.currentTarget as HTMLButtonElement).style.borderColor =
            'var(--curve-border, #E5E5E5)';
          (e.currentTarget as HTMLButtonElement).style.color =
            'var(--curve-text-muted, #64748B)';
        }
      }}
    >
      🔍
    </button>
  );
}
